import { render, staticRenderFns } from "./editorAssemblyPopover.vue?vue&type=template&id=2ee70c4b&"
import script from "./editorAssemblyPopover.vue?vue&type=script&lang=js&"
export * from "./editorAssemblyPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports